<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="iconSize"
    :height="iconSize"
    viewBox="0 0 24 24"
    fill="currentColor"
    class="veke-lamp"
  >
    <path
      d="M21.95,19.7c-0.4-4.42-3.92-7.99-8.51-8.63c-0.21-0.03-0.37-0.19-0.4-0.39c-0.08-0.54-0.61-0.92-1.18-0.85c-0.46,0.06-0.82,0.41-0.89,0.85c-0.03,0.2-0.19,0.36-0.4,0.39c-4.59,0.63-8.12,4.21-8.52,8.63H21.95z M12,23.09c1.52,0,2.83-1.01,3.16-2.42H8.84C9.17,22.08,10.48,23.09,12,23.09 M10.11,10.23c0.21-0.63,0.75-1.1,1.42-1.26V0h0.95v8.97c0.67,0.16,1.2,0.64,1.42,1.26c5.08,0.85,8.84,4.98,9.03,9.91c0.01,0.25-0.19,0.46-0.46,0.47c-0.01,0-0.01,0-0.02,0h-6.32c-0.36,2.18-2.5,3.68-4.78,3.34c-1.8-0.27-3.21-1.62-3.49-3.34H1.55c-0.26,0-0.47-0.2-0.47-0.45c0-0.01,0-0.01,0-0.02C1.26,15.21,5.03,11.08,10.11,10.23"
    />
  </svg>
</template>

<script>
import Icon from './Icon'

export default Icon('LampIcon')
</script>
